import { hidePartialString } from "../../shared/utils/hidePartialString";
import { CopyButton } from "../Components/Buttons/CopyButton";
import styles from "./styles.module.css";

interface Props {
  refValue: string;
}

export const ObjectRefContainer = ({ refValue }: Props) => {
  return (
    <div className={styles.idContainer}>
      <div>REF: {hidePartialString(refValue)}</div>
      <CopyButton
        copyContent={refValue}
        className={styles["ref-copy-button"]}
      />
    </div>
  );
};
